// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import bus from './library/EventBus.js'
import * as Api from './library/ServerApi.js'
import { scrollTop } from './library/Var.js'

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s',
    s: '幾秒前',
    ss: '%d 秒',
    m: '一分鐘前',
    mm: '%d 分鐘',
    h: '一小時前',
    hh: '%d 小時',
    d: '一天前',
    dd: '%d 天',
    M: '一個月前',
    MM: '%d 月',
    y: '一年前',
    yy: '%d 年'
  }
})

Vue.prototype.$moment = moment
Vue.prototype.$api = Api
Object.defineProperty(Vue.prototype, '$bus', {
  get () {
    return this.$root.bus
  }
})
Object.defineProperty(Vue.prototype, '$scrollTop', {
  get () {
    return scrollTop
  }
})

Vue.config.productionTip = process.env.NODE_ENV === 'development'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<app />',
  data () {
    return {
      bus
    }
  },
  router,
  components: { App }
})
